import { render, staticRenderFns } from "./ParentDetails.vue?vue&type=template&id=368ee4ac"
import script from "./ParentDetails.vue?vue&type=script&lang=js"
export * from "./ParentDetails.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ParentDetails.vue?vue&type=style&index=1&id=368ee4ac&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports